import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {useGrowthBook} from '@/contexts/GrowthBookContext'
import {PAGE_DOCS_FEATURE_KEY, resolvePageDocs, type PageDocsConfig} from '@/routes/pageDocs'

/**
 * Docs help-icon configuration for the current page, read from the `emd-page-docs` GrowthBook map keyed by
 * the first path segment, e.g. `{"se-metrics": {"enabled": true, "slug": "se-metrics"}}`.
 * Pages without an entry, or with `enabled` other than true, get no icon.
 */
export const usePageDocs = (): PageDocsConfig => {
  const {pathname} = useLocation()
  const {features} = useGrowthBook()
  const raw: unknown = features[PAGE_DOCS_FEATURE_KEY]

  return useMemo(() => resolvePageDocs(raw, pathname), [raw, pathname])
}
